// removed by extract-text-webpack-plugin
module.exports = {"container":"_1DKb","headerContainer":"_3CmE","wrapper":"_24yS","title":"_3mZo","textContainer":"_3blf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BlogPost/styles.scss
// module id = 514
// module chunks = 0